/**
 * @description Specifies the different alignment types and provides some helper functions
 */
export const AlignmentType = {
  0: 'horizontal',
  1: 'vertical',
  'horizontal': 0,
  'vertical': 1,

  /**
   * @description Returns true, if the given alignment type is horizontal
   * @param {string|number} option An alignment type
   * @returns {boolean} True, if alignment type is horizontal
   */
  isHorizontal( option ) {
    return !option || option === 0 || option === 'horizontal';
  },

  /**
   * @description Returns true, if the given alignment type is vertical
   * @param {string|number} option An alignment type
   * @returns {boolean} True, if alignment type is vertical
   */
  isVertical( option ) {
    return !this.isHorizontal( option );
  }
};